import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';
import Image from 'next/image';
import Script from 'next/script';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  ImageFragment,
  MlBattProtEuProjectDocument,
  MlBattProtEuProjectQuery,
  MlBattProtEuProjectQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';
import EnhancedPolicyPageWrapper from '@/components/shared/EnhancedPolicyPageWrapper';

export const getStaticProps: GetStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: MlBattProtEuProjectDocument });
  await client.query({ query: FooterDocument });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument });

  const { data: mlBattProtEuProject } = await client.query<
    MlBattProtEuProjectQuery,
    MlBattProtEuProjectQueryVariables
  >({
    query: MlBattProtEuProjectDocument,
  });

  return addApolloState(client, {
    props: {
      footerData,
      headerData,
      mlBattProtEuProject,
    },
  });
};

const MlBattProtEuProject: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ footerData, headerData, mlBattProtEuProject }) => (
  <Layout invertedColor footerData={footerData} headerData={headerData}>
    <Script
      src="https://dash.accessiblyapp.com/widget/019a10bb-3053-73c4-a936-8dfff7f7a5c9/autoload.js"
      strategy="afterInteractive"
    />
    <Seo seo={mlBattProtEuProject.mlBattProtEuProject?.data?.attributes?.seo} />
    <EnhancedPolicyPageWrapper
      data={mlBattProtEuProject.mlBattProtEuProject?.data?.attributes?.contents}
    >
      {mlBattProtEuProject.mlBattProtEuProject?.data?.attributes?.logos && (
        <div className="flex flex-wrap gap-8">
          {mlBattProtEuProject.mlBattProtEuProject?.data?.attributes?.logos.map(
            (logo: ImageFragment) => (
              <Image
                key={logo.alt}
                src={logo.img_desktop.data?.attributes?.url ?? ''}
                alt={logo.alt || 'Alt for image'}
                width={4096}
                height={983}
                className="h-11 w-fit object-contain"
              />
            ),
          )}
        </div>
      )}
    </EnhancedPolicyPageWrapper>
  </Layout>
);

export default MlBattProtEuProject;
